module.exports = __webpack_public_path__ + "static/fipcahoywhale3-5934f9434ec6b1b5618b144beff6162a.jpeg";